import { render, staticRenderFns } from "./ConsultationsPast.vue?vue&type=template&id=9e32281a&"
import script from "./ConsultationsPast.vue?vue&type=script&lang=js&"
export * from "./ConsultationsPast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports